// TODO: this doesn't need to be a form, since each step has a form inside,
// and getValues() has nothing in it...

import React, { useState } from 'react';
import { useStateMachine } from 'little-state-machine';
import { updateAction } from '../MultipartForm/stateMachineActions';

import { MPFReviewStepProps, TSubmissionStatus } from '../../util/types';
import CTA from '../MultipartForm/CTA';

import { downloadBlobFile } from '../../util/downloadFile';

// TODO: put 90% of this into a super class or interface or something
const ReviewStep = (props: MPFReviewStepProps) => {
  const { state } = useStateMachine({ updateAction });


  const [submissionStatus, setSubmissionStatus] = useState({
    state: 'not-submitted' as TSubmissionStatus,
    message: '',
  });

  const onSubmit = async () => {

    setSubmissionStatus({
      state: 'loading',
      message: 'Loading...',
    });

    let hadError = false;

    const isDev = process.env.NODE_ENV !== 'production';
    const url = `${isDev ? 'http://localhost:8000' : ''}/api/application/`;

    const csrfField = document.querySelector('[name="_csrf"]') as HTMLInputElement;
    const _csrf = csrfField ? csrfField.value : 'missing';

    const data = {
      ...state.formData,
      students: state.students,
      _csrf,
    };

    console.log('data:', data);

    // Submit application
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        // credentials: 'same-origin',
        body: JSON.stringify(data),
      });

      const responseJson = await response.json();
      // console.log(responseJson);

      // Download the PDF
      const pdfBuffer = new Uint8Array(responseJson.pdf.data);
      const blob = new Blob([pdfBuffer], { type: 'application/pdf', });
      downloadBlobFile(blob, 'YCF_Application', 'pdf');
      // const responseJson = await response.text();

    } catch (err) {
      hadError = true;
      console.error('Error submitting application: ', err);
    }

    if (hadError) {
      setSubmissionStatus({
        state: 'fail',
        message: 'Submission unsuccessful. Please try again.',
      });
    } else {
      // Set done flag so it shows success message (in MultipartForm)
      if (!props.setDone) {
        console.error('ReviewStep is missing props.setDone()');
        return;
      }
      props.setDone(true);
      // It's alreadying showing the DoneScreen at this point
      // setSubmissionStatus({
      //   state: 'success',
      //   message: 'submission success',
      // });
    }

    // props.next();
    // props.history.push('./step2');
  };
  const onBack = (e: React.MouseEvent) => {
    e.preventDefault();
    // handleSubmit(onSubmit);
    props.prev();
  };

  // Transform steps so I can make display them in reviewMode
  const nonEditableSteps = props.steps.map((step, i) => {
    const updatedStep = React.cloneElement(step,
      {...step.props,
        // NOTE: I need to hardcode the indices here because the ReviewSteps component's
        // steps array is the original one with all the no-ops
        returnToStep: (name: string) => props.goToStep(i, name),
        // next: props.next,
        // prev: props.prev,
        reviewMode: true,
      });

    return (
      <div className="ReviewStep" key={i}>
        {updatedStep}

        { // If not on last iteration, draw hr
          props.steps.length !== i + 1
          ? <hr/>
          : undefined
        }
      </div>
    );
  });

  return (
    <div className="ReviewStep">
      <CTA
        background="yellow"
        heading="Please review your information :)"
      >
        <p>
          You’re almost finished! Please review the information below to confirm everything is correct. If you have any questions, please don’t hesitate to <a href="mailto:YCF@bepwr.ca?subject=YCF%20Application%20Question">contact us.</a>
        </p>
      </CTA>
      <div className="page-width page-width--sm mobile-padding row middle-xs center-xs">
        {nonEditableSteps}
      </div>

      <div className="bottom-buttons">
        { submissionStatus.message ?
          <p className={`Form__status-message Form__status-message--${submissionStatus.state}`}>
            {submissionStatus.message}
          </p>
        : null }
        <button disabled={submissionStatus.state === 'loading'} onClick={onBack} className="btn btn--back">Back</button>
        <button disabled={submissionStatus.state === 'loading'} onClick={onSubmit}>Download and Submit</button>
      </div>
    </div>
  );
};

export default ReviewStep;
